// src/components/ProductCardSkeleton.tsx

const ProductCardSkeleton = () => {
  return (
    <div className="group/card ui-card relative flex h-full flex-col overflow-hidden animate-pulse">
      {/* Image Skeleton - Square Aspect Ratio matching ProductCard */}
      <div className="relative block aspect-square w-full overflow-hidden bg-gray-100" />
      
      <div className="flex flex-grow flex-col p-3">
        {/* Title Skeleton - Matching min-height of 2 lines */}
        <div className="mb-2 block min-h-[2.5rem] sm:min-h-[2.75rem]">
          <div className="h-4 w-5/6 rounded bg-gray-200" />
          <div className="mt-1.5 h-4 w-3/5 rounded bg-gray-200" />
        </div>

        {/* Price & Button Skeleton */}
        <div className="mt-auto pt-1">
          <div className="mb-2 flex items-baseline gap-2">
            <div className="h-5 w-16 rounded bg-gray-200" />
            <div className="h-3 w-10 rounded bg-gray-200" />
          </div>

          <div className="mt-3 flex min-h-10 sm:min-h-11 w-full items-center rounded-lg bg-gray-200" />
        </div>
      </div>
    </div>
  );
};

export default ProductCardSkeleton;